$(document).ready(function(){
  function initBrandsSlider() {
    if ($(window).width() <= 500) {
      if (!$('.brands_list_content.slick-brands').hasClass('slick-initialized')) {
        $('.brands_list_content.slick-brands').slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          adaptiveHeight: true,
          prevArrow: '<button type="button" class="slick-prev brands-prev"><i class="fal fa-chevron-left"></i></button>',
          nextArrow: '<button type="button" class="slick-next brands-next"><i class="fal fa-chevron-right"></i></button>',
        });
      }
    } else {
      if ($('.brands_list_content.slick-brands').hasClass('slick-initialized')) {
        $('.brands_list_content.slick-brands').slick('unslick');
      }
    }
  }

  initBrandsSlider();
  $(window).on('resize', function() {
    initBrandsSlider();
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var itemsPerPage = 20; // 1ページに表示するアイテム数を設定
  var items = document.querySelectorAll('.brands_list_content_li');
  var totalItems = items.length;
  var totalPages = Math.ceil(totalItems / itemsPerPage);

  // ページネーションリンクを動的に生成
  var pagination = document.querySelector('.pagination');
  
  // pagination 要素が存在するか確認
  if (pagination) {
    // 既存のリンクを削除
    pagination.innerHTML = '';

    // 2ページ以上の場合にのみページネーションを表示
    if (totalPages > 1) {
      for (var i = 1; i <= totalPages; i++) {
        var link = document.createElement('a');
        link.href = "#";
        link.classList.add('pagination-link');
        link.dataset.page = i;
        link.textContent = i;
        pagination.appendChild(link);
      }

      function showPage(page) {
        // すべてのアイテムを非表示にする
        items.forEach(function(item, index) {
          item.style.display = 'none';
        });

        // 対応するページのアイテムを表示
        var start = (page - 1) * itemsPerPage;
        var end = start + itemsPerPage;
        for (var i = start; i < end && i < totalItems; i++) {
          items[i].style.display = 'block';
        }
      }

      // 初期表示
      showPage(1);

      // ページリンクのクリックイベント
      var links = document.querySelectorAll('.pagination-link');
      links.forEach(function(link) {
        link.addEventListener('click', function(event) {
          event.preventDefault();
          var page = parseInt(this.dataset.page);
          showPage(page);

          // 現在のページを強調表示
          links.forEach(function(link) {
            link.classList.remove('active');
          });
          this.classList.add('active');
        });
      });
    } else {
      // ページ数が1の場合、ページネーションのリンクを非表示にする
      pagination.style.display = 'none';
      // ページ1のコンテンツは表示させる
      items.forEach(function(item) {
        item.style.display = 'block';
      });
    }
  } else {
    console.error('Pagination element not found.');
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".tab-link");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", function() {
      tabs.forEach(t => t.classList.remove("current"));
      contents.forEach(content => content.classList.remove("current"));

      tab.classList.add("current");
      document.getElementById(tab.getAttribute("data-tab")).classList.add("current");
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
    // 年齢確認のチェックボックスを取得
    var ageCheckbox = document.querySelector('input[name="age_verification"]');

    // 年齢確認のチェックボックスが存在する場合のみ制御を適用
    if (ageCheckbox) {
        // 「カートに追加」ボタンと「今すぐ購入」ボタンを取得
        var addToCartButton = document.querySelector('button[name="add"]');
        var buyNowButton = document.querySelector('.shopify-payment-button__button');

        // 初期状態でボタンを無効化
        addToCartButton.disabled = true;
        buyNowButton.disabled = true;
        addToCartButton.style.backgroundColor = '#ccc'; // カートボタンの背景色をグレーに変更
        buyNowButton.style.backgroundColor = '#ccc'; // 今すぐ購入ボタンの背景色をグレーに変更

        // チェックボックスの状態が変わったときにボタンの状態を更新
        ageCheckbox.addEventListener('change', function () {
            if (ageCheckbox.checked) {
                addToCartButton.disabled = false;
                buyNowButton.disabled = false;
                addToCartButton.style.backgroundColor = ''; // カートボタンの元の背景色に戻す
                buyNowButton.style.backgroundColor = ''; // 今すぐ購入ボタンの元の背景色に戻す
            } else {
                addToCartButton.disabled = true;
                buyNowButton.disabled = true;
                addToCartButton.style.backgroundColor = '#ccc'; // カートボタンの背景色をグレーに変更
                buyNowButton.style.backgroundColor = '#ccc'; // 今すぐ購入ボタンの背景色をグレーに変更
            }
        });
    }
});